import {Events, EventType} from '../events/Events';

/**
 * Enumeration of possible breakpoints.
 */
export enum Breakpoint {
  PHONE            = 0,
  TABLET_PORTRAIT  = 1,
  TABLET_LANDSCAPE = 2,
  DESKTOP          = 3
}

/**
 * Mapping of breakpoints to font-family values used in CSS.
 *
 * Keep in sync with FernrauschApp.scss!
 */
const BreakpointFontFamily = {
  PHONE:            'PHONE',
  TABLET_PORTRAIT:  'TABLET_PORTRAIT',
  TABLET_LANDSCAPE: 'TABLET_LANDSCAPE',
  DESKTOP:          'DESKTOP'
};

let recentBreakpoint: Breakpoint | undefined;

/**
 * Returns the current breakpoint.
 */
export const getBreakpoint = (): Breakpoint => {
  const breakpointDetectorElement = document.getElementById('breakpoint-detector') as HTMLElement;
  const breakpointDetectorFontFamily = window.getComputedStyle(breakpointDetectorElement)?.fontFamily;

  if (breakpointDetectorFontFamily?.includes(BreakpointFontFamily.PHONE)) {
    return Breakpoint.PHONE;
  } else if (breakpointDetectorFontFamily.includes(BreakpointFontFamily.TABLET_PORTRAIT)) {
    return Breakpoint.TABLET_PORTRAIT;
  } else if (breakpointDetectorFontFamily.includes(BreakpointFontFamily.TABLET_LANDSCAPE)) {
    return Breakpoint.TABLET_LANDSCAPE;
  } else if (breakpointDetectorFontFamily.includes(BreakpointFontFamily.DESKTOP)) {
    return Breakpoint.DESKTOP;
  } else {
    console.warn(`Unknown breakpoint, defaulting to DESKTOP: ${breakpointDetectorFontFamily}`);
    return Breakpoint.DESKTOP;
  }
};

// Publish an event when the breakpoint changes.
window.addEventListener('resize', () => {
  const newBreakpoint = getBreakpoint();
  if (newBreakpoint !== recentBreakpoint) {
    Events.publish(EventType.BREAKPOINT_CHANGED);
  }
  recentBreakpoint = newBreakpoint;
});
